import { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import "./ListNotes.css";
import { Button, Col, Container, Row, Table, Image } from "react-bootstrap";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import asc from "../../assets/images/asc.png";
import desc from "../../assets/images/desc.png";
import edit from "../../assets/images/edit.svg";
import reverseArrow from "../../assets/images/reverseArrow.svg";
import Loader from "../common/Loader";
import { formatDate } from "../common/helper";
import Pagination from "../common/Pagination/Pagination";

function ListNotes(props) {
  const user = JSON.parse(localStorage.getItem("leadUser"));
  const [accountsDropdown, setAccountsDropdown] = useState([]);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [notes, setNotes] = useState([]);
  const [filteredNotes, setFilteredNotes] = useState([]);
  const [paginatedNotes, setPaginatedNotes] = useState([]);
  const [loading, setLoading] = useState(false);
  //for pagination
  const itemsPerpage = 20;
  const [itemOffset, setItemOffset] = useState(0);
  const [, setEndOffset] = useState(itemsPerpage);
  const [, setSelectedItems] = useState([]);
  const [accountId, setAccountId] = useState(null);
  const [customerName, setCustomerName] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [editNoteId, setEditNoteId] = useState(null);
  const [editNoteText, setEditNoteText] = useState("");

  function sortField(sortingField, direction) {
    let sorted;
    switch (sortingField) {
      case "accCustomer":
        sorted = [...filteredNotes].sort((a, b) =>
          direction === "ASC"
            ? a.accountFullName.localeCompare(b.accountFullName)
            : b.accountFullName.localeCompare(a.accountFullName),
        );
        setFilteredNotes(sorted);
        break;
      case "accNoteDate":
        sorted = [...filteredNotes].sort((a, b) => {
          const dateA = new Date(a.noteDate);
          const dateB = new Date(b.noteDate);
          return direction === "ASC" ? dateA - dateB : dateB - dateA;
        });
        setFilteredNotes(sorted);
        break;
      case "accLead":
        sorted = [...filteredNotes].sort((a, b) =>
          direction === "ASC"
            ? (a.leadName || "").localeCompare(b.leadName || "")
            : (b.leadName || "").localeCompare(a.leadName || ""),
        );
        setFilteredNotes(sorted);
        break;
      case "accVehicle":
        sorted = [...filteredNotes].sort((a, b) =>
          direction === "ASC"
            ? (a.vehicleNumber || "").localeCompare(b.vehicleNumber || "")
            : (b.vehicleNumber || "").localeCompare(a.vehicleNumber || ""),
        );
        setFilteredNotes(sorted);
        break;
      case "accNote":
        sorted = [...filteredNotes].sort((a, b) =>
          direction === "ASC"
            ? (a.note || "").localeCompare(b.note || "")
            : (b.note || "").localeCompare(a.note || ""),
        );
        setFilteredNotes(sorted);
        break;
      default:
        break;
    }
  }

  function filterNotes(e) {
    const [accountId, locationNumber] = e.value.split("#~#");
    if (accountId === "all") {
      setFilteredNotes(notes);
    } else {
      const filtered = notes.filter(
        (note) =>
          note.accountId === parseInt(accountId) &&
          note.locationNumber === parseInt(locationNumber),
      );
      setFilteredNotes(filtered);
    }
  }

  function tableFieldsHeading(labelName, fieldName) {
    return (
      <div className="table-fields-heading">
        <label className="table-fields-labels">{labelName}</label>
        {fieldName === null ? null : (
          <div className="sorting-div">
            <Image
              src={asc}
              className="sorting-btns"
              style={{ cursor: "pointer" }}
              onClick={() => {
                sortField(fieldName, "ASC");
              }}
            ></Image>
            <Image
              src={desc}
              className="sorting-btns"
              style={{ cursor: "pointer" }}
              onClick={() => {
                sortField(fieldName, "DSC");
              }}
            ></Image>
          </div>
        )}
      </div>
    );
  }

  function setNotesList() {
    let count = itemOffset;

    return paginatedNotes.map((item, index) => {
      count = count + 1;
      return (
        <tr key={index} className="acc-table-row">
          <td style={{ paddingTop: "15px" }}>{count}</td>
          <td style={{ paddingTop: "15px" }}>{item.accountFullName}</td>
          <td style={{ paddingTop: "15px" }}>{formatDate(item.noteDate)}</td>
          <td style={{ paddingTop: "15px" }}>{item.leadName}</td>
          <td style={{ paddingTop: "15px" }}>{item.vehicleNumber}</td>
          <td style={{ paddingTop: "15px" }}>{item.note}</td>
          <td style={{ paddingTop: "15px" }}>
            {user.roleCode === "SADM" ||
            user.roleCode === "Admin" ||
            item.leadId === user.id ? (
              <img
                src={edit}
                style={{ width: "24px", cursor: "pointer" }}
                alt={"arrow-icon"}
                onClick={() => {
                  setIsEditMode(true);
                  setEditNoteId(item.id);
                  setEditNoteText(item.note);
                  setCustomerName(item.accountFullName);
                  setAccountId(item.accountId);
                }}
              />
            ) : null}
          </td>
        </tr>
      );
    });
  }

  function getNotesData() {
    let notesData = {
      id: editNoteId,
      accountId: parseInt(accountId),
      note: editNoteText,
    };
    return notesData;
  }

  function resetEditMode() {
    setIsEditMode(false);
    setEditNoteId(null);
    setAccountId(null);
    setEditNoteText("");
  }

  useEffect(() => {
    props.setTab("notes");
  }, [props]);

  useEffect(() => {
    props.notesList.forEach((note) => {
      note.accountFullName = note.accountName + " - " + note.locationName;
    });
    setNotes(props.notesList);
  }, [props.notesList]);

  useEffect(() => {
    const dropDownOptions = [
      ...new Map(
        notes.map((note) => [
          `${note.accountId}#~#${note.locationNumber}`,
          {
            label: note.accountFullName,
            value: `${note.accountId}#~#${note.locationNumber}`,
          },
        ]),
      ).values(),
    ].sort((a, b) => a.label.localeCompare(b.label));

    setAccountsDropdown([{ value: "all", label: "All" }, ...dropDownOptions]);
    setFilteredNotes(
      notes.sort((a, b) => b.noteDate.localeCompare(a.noteDate)),
    );
  }, [notes]);

  useEffect(() => {
    resetEditMode();
    props.resetUpdateSuccess(false);
  }, [props.isUpdateSuccess]);

  return (
    <Container>
      <Row className="button-position">
        <Button
          className="button-width"
          onClick={() => {
            navigate("/notes");
          }}
          variant="primary"
        >
          {t("listNotes.label")}
        </Button>
        <Button
          className="button-width"
          onClick={() => {
            navigate("/sync");
          }}
          variant="primary"
        >
          {t("syncButton.label")}
        </Button>
      </Row>

      <Row
        style={{
          marginTop: "1%",
          display: isEditMode ? "none" : "block",
        }}
      >
        <Form.Label column sm="6">
          {t("account.label")}
        </Form.Label>
        <Col>
          <Select
            options={accountsDropdown}
            defaultValue={"all"}
            onChange={(e) => {
              filterNotes(e);
            }}
          />
        </Col>
      </Row>

      <Row
        style={{
          marginTop: "2%",
          display: isEditMode ? "none" : "block",
        }}
      >
        <Form>
          <Table className="table">
            <thead>
              <tr className="table-heading">
                <th>#</th>
                <th>{tableFieldsHeading("Customer", "accCustomer")}</th>
                <th>{tableFieldsHeading("Date", "accNoteDate")}</th>
                <th>{tableFieldsHeading("Lead", "accLead")}</th>
                <th>{tableFieldsHeading("Vehicle", "accVehicle")}</th>
                <th>{tableFieldsHeading("Note", "accNote")}</th>
                <th>{tableFieldsHeading(" ", null)}</th>
              </tr>
            </thead>
            <tbody>
              {notes.length > 0 ? (
                setNotesList()
              ) : (
                <tr>
                  <td colSpan="6" style={{ textAlign: "center" }}>
                    {loading ? <Loader loading={loading} /> : "No data found"}
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Form>
      </Row>

      <Row
        style={{
          paddingRight: "0px",
          paddingLeft: "25px",
          display: isEditMode ? "block" : "none",
        }}
      >
        <Col sm="7" style={{ padding: "15px 5px" }}>
          <div
            onClick={() => {
              setIsEditMode(false);
              setEditNoteId(null);
              setEditNoteText("");
            }}
          >
            <img className="back-arrow" src={reverseArrow} alt={"arrow-icon"} />
            <span className="back-tag">Back</span>/{customerName}
          </div>
        </Col>
        <Row className="form-align-center">
          <Form.Group as={Col} className="mb-3" controlId="formPlaintextNotes">
            <Row>
              <Form.Label column sm="4">
                {t("editNote.label")}
              </Form.Label>
            </Row>
            <Row>
              <Col sm="12">
                <Form.Control
                  value={editNoteText}
                  onChange={(e) => {
                    setEditNoteText(e.target.value);
                  }}
                />
              </Col>
            </Row>
          </Form.Group>
          <Row className="form-align-center" style={{ padding: "1px 10px" }}>
            <Button
              className="login-btn"
              style={{ margin: "auto" }}
              disabled={!editNoteText}
              onClick={async (e) => {
                e.preventDefault();
                props.onSave(getNotesData());
              }}
            >
              <label className="login-btn-label">{t("save.label")}</label>
            </Button>
          </Row>
        </Row>
      </Row>

      <Row
        style={{
          marginBottom: "15%",
          zIndex: "0",
          display: isEditMode ? "none" : "block",
        }}
      >
        {filteredNotes.length > 0 ? (
          <Pagination
            items={filteredNotes}
            currentItems={setPaginatedNotes}
            itemsPerpage={itemsPerpage}
            itemOffset={setItemOffset}
            endOffset={setEndOffset}
            clearSelectedItems={setSelectedItems}
          />
        ) : null}
      </Row>
    </Container>
  );
}

export default ListNotes;
